/**
 * Within the experience app, ENTER opens the full curriculum.
 * The original homepage links here via ./experience/
 */
export const ENTER_URL = "#/learn";

export const SITE = {
  name: "cannac",
  tagline: "Craft cannabis culture",
  promise: "Cannabis, explained — as deep as you want.",
  locale: "en-GB",
  url: "https://cannac.co.uk/",
} as const;
